import React, { useState } from "react";
import Menus from "./menus";
import MenuTranslation from "./menu-translation";



export default function MenuManagement() {
    const [menuId, setMenuId] = useState()
    return (
        <div>
            {/* <button name="DenemeButon" onClick={()=>{setCount(count+1)}}>{count}</button> */}
            {/* <button name="DenemeButon">{count}</button> */}
            <Menus setMenuId={setMenuId} />
            <MenuTranslation menuId={menuId} />

        </div>
    )


}